import type { Competition } from '@/types/domain';
import type { SportFilterValue } from '@/components/shared/SportFilter';

export const filterCompetitionsBySport = (
  competitions: Competition[],
  selectedSport: SportFilterValue
): Competition[] => {
  if (selectedSport === 'ALL') return competitions;
  return competitions.filter(c => c.sport?.toUpperCase() === selectedSport);
};
